import { FrameProduct, SizeLabel } from '../';

export function IsLargeSize(product: FrameProduct): product is FrameProduct {
  return product.drawableObject.sizeLabel === SizeLabel.L;
}
